import PaymentsForInvoiceDatagrid from 'src/components/EntityDatagrids/PaymentsForInvoiceDatagrid';

const PaymentsInvoicePage = () => (<PaymentsForInvoiceDatagrid />);
export default PaymentsInvoicePage;
